export type ScreenSizeToken = typeof screenSizeTokens;
export type Breakpoints = typeof breakpoints;

export const breakpoints = {
  xsmall: 640,
  small: 960,
  medium: 1280,
};

export const screenSizeTokens = {
  $xsmall: `@media (max-width: ${breakpoints.xsmall}px)`,
  $small: `@media (max-width: ${breakpoints.small}px)`,
  $medium: `@media (max-width: ${breakpoints.medium}px)`,
};
